var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToastInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#515151;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-101 -571)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3 -9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -1)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(103 581)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-.031-8.6a4.219,4.219,0,0,0-.523.034q-.268.034-.4.06v5.892a.6.6,0,0,0,.248.523,1.816,1.816,0,0,0,.96.174,4.22,4.22,0,0,0,.523-.034q.268-.034.4-.06V-7.906A.6.6,0,0,0,.929-8.43,1.816,1.816,0,0,0-.031-8.6ZM.117-1.1a1.072,1.072,0,0,0-.778.315,1.039,1.039,0,0,0-.322.772A1.061,1.061,0,0,0-.662.764a1.061,1.061,0,0,0,.778.322A1.061,1.061,0,0,0,.9.764a1.061,1.061,0,0,0,.322-.778A1.039,1.039,0,0,0,.9-.786,1.072,1.072,0,0,0,.117-1.1Z",
    transform: "translate(111.984 593.598)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastInfo);
export default __webpack_public_path__ + "static/media/toast-info.72d0642c1e156a72fca45717d4fd98b8.svg";
export { ForwardRef as ReactComponent };